export default function (page, orderBy, isAscending) {
  let returnObject = { p: page };
  if (orderBy) {
    returnObject = { ...returnObject, o: orderBy, a: isAscending };
  }
  return returnObject;
}
